import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  LogoLoader,
  SmartTooltip,
  StatusTags,
  TableAdv,
} from "../../../../components";
import { Link, useNavigate } from "react-router-dom";
import { mapTableRows } from "../../../../utils/mapTableRows";
//
import { useSelector, useDispatch } from "react-redux";
import {
  getEmployeesStart,
  setEmployeeProfileUiid,
} from "../../../../redux/slices/employee/employeeSlice";
import {
  getValueByKey,
  formatWords,
  dateFormator,
  getEmployeeId,
} from "../../../../utils";
import { usePagination } from "../../../../hooks";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../redux/apiConfig";

const BenchConsultants = () => {
  const [searchValue, setSearchValue] = useState("");
  const [total, setTotalCount] = useState(0);
  const dispatch = useDispatch();
  const [sortConfig, setSortConfig] = useState({ field: "uiid", direction: 1 });
  const { loading, error, employees, totalCount } = useSelector(
    (state) => state.employee,
  );
  const isLoading = loading;
  const paginationMemory = localStorage.getItem("all-bench-limit") || 25;
  const { page, limit, setPage, handleLimitChange } =
    usePagination(paginationMemory);

  const tableData = employees?.data || []; // Add null check with default empty array

  const handleEdit = (row) => {
    alert(row.code);
    //console.log("row", row._id);
  };

  // Handle sort function
  const handleSort = (field) => {
    setSortConfig((prevSort) => ({
      field,
      // Toggle between 1 (ascending) and -1 (descending)
      direction: prevSort.field === field ? -prevSort.direction : 1,
    }));
  };

  const columns = [
    //{ key: "uiid", label: "Id" },
    // { key: "code", label: "Code" },
    {
      key: "code",
      label: "Code",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            //state={{ code: row.code, dataId: row._id }}
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            <span className="text-linkblue">
              {getEmployeeId(row.uiid, row.employmentType)}
            </span>
          </Link>
        </div>
      ),
      sortfun: () => handleSort("uiid"),
    },

    {
      key: "firstName",
      label: "First Name",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.firstName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="flex items-center gap-2">
            <Avatar
              alt={row.firstName}
              size="sm"
              outline
              src={row.profilePhotoUrl}
            />
            <Link
              to="/employee/employee-profile"
              onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
              className="truncate max-w-[200px]"
            >
              {row.firstName}
            </Link>
          </div>
        </SmartTooltip>
      ),
      sortfun: () => handleSort("firstName"),
    },
    {
      key: "lastName",
      label: "Last Name",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.lastName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">
            <Link
              to="/employee/employee-profile"
              onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
            >
              {row.lastName}
            </Link>
          </div>
        </SmartTooltip>
      ),
      sortfun: () => handleSort("lastName"),
    },
    {
      key: "middleName",
      label: "Middle Name",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.middleName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">
            <Link
              to="/employee/employee-profile"
              onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
            >
              {row.middleName}
            </Link>
          </div>
        </SmartTooltip>
      ),
      sortfun: () => handleSort("middleName"),
    },
    {
      key: "employmentType",
      label: "Employment Type",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            //state={{ code: row.code, dataId: row._id }}
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            {formatWords(
              "",
              getValueByKey(row.employmentType, "EmploymentType"),
            )}
          </Link>
        </div>
      ),
      sortfun: () => handleSort("employmentType"),
    },
    {
      key: "status",
      label: "Employee Status",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            //state={{ code: row.code, dataId: row._id }}
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            <StatusTags
              tag={formatWords("", getValueByKey(row.status, "EmployeeStatus"))}
            />
          </Link>
        </div>
      ),
      sortfun: () => handleSort("status"),
    },
    //{ key: "contactNo", label: "Contact No" },
    {
      key: "email",
      label: "Email ID",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            //state={{ code: row.code, dataId: row._id }}
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            <span className="text-linkblue">{row.email.primary}</span>
          </Link>
        </div>
      ),
      sortfun: () => handleSort("email.primary"),
    },
    {
      key: "alternateEmailId",
      label: "Alternate Email ID",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            //state={{ code: row.code, dataId: row._id }}
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            <span className="text-linkblue">{row.email.secondary || "-"}</span>
          </Link>
        </div>
      ),
      sortfun: () => handleSort("email.secondary"),
    },
    {
      key: "category",
      label: "Category",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to="/employee/employee-profile"
            //state={{ code: row.code, dataId: row._id }}
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            {row?.category ? row?.category : "-"}
          </Link>
        </div>
      ),
    },

    {
      key: "location",
      label: "Country",
      width: "text-nowrap",
      render: (row) => (
        <Link
          to="/employee/employee-profile"
          //state={{ code: row.code, dataId: row._id }}
          onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
        >
          <div className="flex items-center gap-1">{row.location.country}</div>
        </Link>
      ),
      sortfun: () => handleSort("location"),
    },
    {
      key: "cityState",
      label: "City/State",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => {
        const value = `${row?.location?.city || ""}, ${row?.location?.state || ""}`;

        return (
          <SmartTooltip
            description={value}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div className="flex items-center gap-1 line-clamp-1!">
              <Link
                to="/employee/employee-profile"
                onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
              >
                {value}
              </Link>
            </div>
          </SmartTooltip>
        );
      },
      sortfun: () => handleSort("cityState"),
    },
    {
      key: "fullAddress",
      label: "Full Address",
      width: "min-w-[200px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
            description={row.location.address1}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
        <Link
          to="/employee/employee-profile"
          onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
        >
          <div className="flex items-center gap-1 line-clamp-1!">{row.location.address1}</div>
        </Link>
        </SmartTooltip>
      ),
      sortfun: () => handleSort("fullAddress"),
    },

    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[250px]! max-w-[350px]!",
      sortfun: () => handleSort("jobTitle"),
      render: (row) => (
        <SmartTooltip
          description={row.jobTitle}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <Link
            to="/employee/employee-profile"
            onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
          >
            <div className="flex items-center gap-1 line-clamp-1!">
              {row.jobTitle ? row.jobTitle : "-"}
            </div>
          </Link>
        </SmartTooltip>
      ),
    },
    {
      key: "joinDate",
      label: "Date of Joining",
      render: (row) => (
        <Link
          to="/employee/employee-profile"
          //state={{ code: row.code, dataId: row._id }}
          onClick={() => dispatch(setEmployeeProfileUiid(row.uiid))}
        >
          {dateFormator(row.joinDate, "month-day-year")}
        </Link>
      ),

      sortfun: () => handleSort("joinDate"),
    },
    // { key: "profileType", label: "Type of Profile" },
    {
      key: "",
      label: "Action",
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          icon="edit"
          size="xs"
          color="black"
          onClick={() => handleEdit(row)}
        />
      ),
      sortable: false, // Ensure sorting is disabled for this column
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);

  // Reset page to 1 when search changes
  useEffect(() => {
    setPage(1);
  }, [searchValue]);

  useEffect(() => {
    dispatch(
      getEmployeesStart({
        limit,
        page,
        useAggregate: true,
        filters: {
          // employmentType: { type: "NONE", value: 2 },
          // "isExit.status": { type: "NONE", value: false },
          // onBench: { type: "NONE", value: true },
          benchEmps: {
            type: "AG_LOOKUP_DATA",
            // value: [{ [sortConfig.field]: sortConfig.direction }1],
            value: [1, [1, 4], 1, searchValue],
          },
        },
        // ret: "uiid employmentType profilePhotoUrl firstName middleName lastName status email category location jobTitle joinDate",
        sort: { [sortConfig.field]: sortConfig.direction },
      }),
    );
    const fetchBenchCount = async () => {
      const count = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.EMPLOYEES.GET_ALL,
        params: {
          coll: "Employee",
          useAggregate: true,
          fil: JSON.stringify({
            benchEmpCount: {
              type: "AG_LOOKUP_DATA",
              //first field employee status type , second field employment type , third field classification
              value: [1, [1, 4], 1],
            },
          }),
        },
      });
      console.log("count", count?.data?.data?.[0]?.TotalCount || 0);
      setTotalCount(count?.data?.data?.[0]?.TotalCount || 0);
    };
    fetchBenchCount();
    const setLimitInLocalStorage = () => {
      localStorage.setItem("all-bench-limit", limit || 0);
    };
    setLimitInLocalStorage();
    setLimitInLocalStorage();
  }, [dispatch, page, limit, sortConfig, searchValue]); // Empty array will cause it to run once when the component mounts

  const handleSearch = (keyname, value) => {
    setSearchValue(value);
  };

  return (
    <div className="flex flex-col overflow-hidden">
      <TableAdv
        tableId={`employees_benchconsultants`}
        rows={mappedRows}
        columns={columns}
        fixedCol={3}
        serverPagination={true}
        totalCount={total}
        page={page}
        limit={limit}
        showSlNo
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        serverSerchValue={searchValue}
        serverOnSearch={handleSearch}
        toolbarRight={{
          search: true,
          filter:true
        }}
      />
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default BenchConsultants;
